<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <img src="../assets/404.png" style="max-width: 300px;">
    <a href="https://www.nebulabuds.com/" target="_blank">Go To Nebula Buds</a>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
export default {
  setup () {
    const router = useRouter()
    const backdd = () => {
      router.back() // 调用路由的 back 方法
    }
    return { backdd }
  }
}
</script>
<style scoped>
  body{background-color: #f00;}
  .container{display: flex;flex-direction: column;width: 100%;height: 100vh;justify-content: center;align-items: center;}
  a{color: #2912a9;font-size: 18px;font-weight: bold;padding: 10px;border:2px solid #2912a9;}
</style>
